"use client";

import * as React from "react";
import { Grid, Box } from "@mui/material"; 

const Widgets = () => {
  return (
    <>
      <Box
        className="fp-widgets-area"
        sx={{
          pb: { xs: "60px", sm: "60px", md: "80px", lg: "100px", xl: "150px" },
        }}
      >
        <Box
          sx={{
            maxWidth: {
              xs: "100%",
              sm: "700px",
              md: "720px",
              lg: "1140px",
              xl: "1320px",
            },
            mx: "auto",
            px: "12px",
            position: "relative",
            zIndex: "1",
          }}
        >
          <Grid
            container
            alignItems="center"
            columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 3 }}
          >
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <div className="fp-widgets-image">
                <div className="image1">
                  <img
                    src="/images/front-pages/aifeatures.png"
                    alt="order-summary-image"
                    width={900}
                    height={600}
                  />
                </div>
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <div className="fp-widgets-content">
                <h2>
                  Supercharge Your Dashboard: AI, Integrations & Custom Solutions Built for You
                </h2>

                <ul className="features-list">
                <li>
                  <i className="material-symbols-outlined">smart_toy</i>
                  <h3 className="fw-semibold">AI-Powered Automation</h3>
                  <p>
                    Integrate intelligent systems that adapt to your data, automate processes, and deliver real-time insights.
                  </p>
                </li>

                <li>
                  <i className="material-symbols-outlined">account_tree</i>
                  <h3 className="fw-semibold">ERP System Integration</h3>
                  <p>
                    Connect seamlessly with ERP platforms like <strong>Odoo</strong>, <strong>ERPNext</strong>, and more—tailored to your business workflows.
                  </p>
                </li>

                <li>
                  <i className="material-symbols-outlined">payments</i>
                  <h3 className="fw-semibold">Secure Payment Integrations</h3>
                  <p>
                    Enable smooth transactions with Local Banks, MPESA, PayPal, and other global/local gateways, fully embedded into your system.
                  </p>
                </li>

                <li>
                  <i className="material-symbols-outlined">devices</i>
                  <h3 className="fw-semibold">Web & Mobile App Development</h3>
                  <p>
                    We build responsive, scalable, and custom web platforms and mobile apps to fit your exact business needs.
                  </p>
                </li>
                </ul>
              </div>
            </Grid>
          </Grid>

          {/* Shape Images */}
          <div className="shape1">
            <img
              src="/images/front-pages/shape1.png"
              alt="shape1"
              width={530}
              height={530}
            />
          </div>
          <div className="shape2">
            <img
              src="/images/front-pages/shape2.png"
              alt="shape2"
              width={447}
              height={453}
            />
          </div>
        </Box>
      </Box>
    </>
  );
};

export default Widgets;
